import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BackendListModel } from "src/app/models/common/list.model";
import { RequestFiltersClass } from "src/app/models/request-filters";
import { ApiRoutes } from "src/app/services/apiroutes";
import { RequestListRootObject } from "../my-orders-table/new-request.model";
import { Subject } from "rxjs";

@Injectable({
    providedIn: 'root'
})

export class MyRequestsService {
    base_url = ApiRoutes.LeadRequest;

    newRequestPageSize = 10;
    newRequestPageNum = 1;
    newRequestPageLength = 0;
    groupInfo = {};

    filterSubject = new Subject<{}>();
    filtersAdded: boolean = false;
    filterList = new RequestFiltersClass();

    constructor(
        private http: HttpClient,
    ) { }


    getNatureOfRequest(request: any) {
        switch (request.request_type.dev_name) {
            case 'lease':
                if (request.transaction_type == 'use')
                    return 'Lease | Use';
                else
                    return 'Lease | Supply';
            case 'one_way':
                if (request.transaction_type == 'use')
                    return 'One Way | Use';
                else
                    return 'One Way | Supply';
            case 'buy_sell':
                if (request.transaction_type == 'use')
                    return 'Trade | Buy';
                else
                    return 'Trade | Sell';
            case 'empty_repo':
                if (request.transaction_type == 'use')
                    return 'Empty Repo | Use';
                else
                    return '';
        }
        return '-';
    }


    getMyRequestsByFilters(groupId, FiltersParams) {
        let url = new URL(`${this.base_url}my_request/`);

        if (FiltersParams.search != null && FiltersParams.search != '') {
            url.searchParams.append('search', FiltersParams.search);
        }
        if (FiltersParams.request_type != null && FiltersParams.request_type != '') {
            url.searchParams.append('request_type', FiltersParams.request_type);
        }
        if (groupId != null) {
            url.searchParams.append('group_id', groupId);
        }
        if (FiltersParams.request_number != null) {
            url.searchParams.append('request_number', FiltersParams.request_number?.request_number);
        }
        if (FiltersParams.requestor__name != null && FiltersParams.requestor__name != '') {
            url.searchParams.append('requestor__name', FiltersParams.requestor__name.name);
        }
        if (FiltersParams.pickup_location_id != null) {
            url.searchParams.append('pickup_location_id', FiltersParams.pickup_location_id.id);
        }
        if (FiltersParams.dropoff_location_id != null) {
            url.searchParams.append('dropoff_location_id', FiltersParams.dropoff_location_id.id);
        }
        if (FiltersParams.container_size_type_id != null) {
            url.searchParams.append('container_size_type_id', FiltersParams.container_size_type_id);
        }
        if (FiltersParams.condition_id != null) {
            url.searchParams.append('condition_id', FiltersParams.condition_id);
        }
        if (FiltersParams.request_date__gte != null) {
            url.searchParams.append('request_date__gte', FiltersParams.request_date__gte);
        }
        if (FiltersParams.request_date__lte != null) {
            url.searchParams.append('request_date__lte', FiltersParams.request_date__lte);
        }
        if (FiltersParams.external_reference_no != null) {
            url.searchParams.append('external_reference_no', FiltersParams.external_reference_no);
        }
        if (FiltersParams.requestor__company != null && FiltersParams.requestor__company != '') {
            url.searchParams.append('requestor__company', FiltersParams.requestor__company);
        }
        if (FiltersParams.request_age_in_days != null) {
            url.searchParams.append('request_age_in_days', FiltersParams.request_age_in_days);
        }
        if (FiltersParams.page_size != null) {
            url.searchParams.append('page_size', String(FiltersParams.page_size));
        }
        if (FiltersParams.page != null) {
            url.searchParams.append('page', String(FiltersParams.page));
        }
        if (FiltersParams.o != null && FiltersParams.o != '') {
            url.searchParams.append('o', FiltersParams.o);
        }

        return this.http.get<BackendListModel<RequestListRootObject>>(url.toString());
    }


    // updateFilterSubjectValue(filterResponse): void {
    //     this.filterSubject.next(filterResponse);
    // }
}
